import api from 'api/api'
import { toast } from 'react-toastify'

export const LOADING_LOGIN = '[AUTH] LOADING LOGIN'
export const LOGIN_SUCCESS = '[AUTH] LOGIN SUCCESS'
export const LOGIN_ERROR = '[AUTH] LOGIN ERROR'
export const LOGOUT = '[AUTH] LOGOUT'

export const UPDATE_PROFILE_IMAGE = '[AUTH] UPLOAD PROFILE IMAGE'
export const REMOVE_PROFILE_IMAGE = '[AUTH] REMOVE PROFILE IMAGE'

export const loginAction = (data = { username: '', password: '' }) => {
  const request = api.post('/auth/login', data)
  return (dispatch) => {
    dispatch({ type: LOADING_LOGIN, payload: true })
    request.then((response) => {
      dispatch({ type: LOGIN_SUCCESS, payload: { user: response.data.user, token: response.data.token } })
    }).catch((error) => {
      dispatch({ type: LOGIN_ERROR, payload: error.response?.data?.message ?? 'Error interno de autenticación' })
    }).finally(() => {
      dispatch({ type: LOADING_LOGIN, payload: false })
    })
  }
}

export const getUserAuthenticatedAction = () => {
  const request = api.get('/auth/user')
  return (dispatch) => {
    dispatch({ type: LOADING_LOGIN, payload: true })
    request.then((response) => {
      dispatch({ type: LOGIN_SUCCESS, payload: { user: response.data.user, token: response.data.token } })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'Error al refrescar su sesión')
      dispatch({ type: LOGOUT })
    }).finally(() => {
      dispatch({ type: LOADING_LOGIN, payload: false })
    })
  }
}

export const updateProfileImageAction = (imageUrl) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_IMAGE, payload: imageUrl })
  }
}